import { AHText, AHTextFonts, Box, useSpaceSize } from "arkh";
import React, { PropsWithChildren, ReactNode } from "react";

import { View } from "react-native";

export function ResultRow({
  children,
  title,
  subTitle,
  stale = false,
}: PropsWithChildren<{
  title: string;
  stale?: boolean;
  subTitle?: React.ReactNode;
}>) {
  return (
    <View
      style={{
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <ResultBlock stale={stale}>{children}</ResultBlock>
      <Box style={{ flex: 1 }}>
        <ResultTitle stale={stale}>{title}</ResultTitle>
        {subTitle ? <ResultSubTitle>{subTitle}</ResultSubTitle> : null}
      </Box>
    </View>
  );
}

export const ResultTitle: React.FC<
  React.PropsWithChildren<{ stale?: boolean }>
> = ({ children, stale = false }) => {
  return (
    <AHText
      numberOfLines={1}
      ellipsizeMode="tail"
      adjustsFontSizeToFit
      type="subtitle"
      minimumFontScale={0.7}
      font={AHTextFonts.BOLD}
      color={stale ? "washedText" : "darkerText"}
      spaceLeft="small"
    >
      {children}
    </AHText>
  );
};
export const ResultSubTitle = ({
  children,
}: {
  children?: ReactNode | undefined;
}) => {
  return (
    <AHText
      numberOfLines={1}
      ellipsizeMode="tail"
      adjustsFontSizeToFit
      type="body"
      minimumFontScale={0.7}
      font={AHTextFonts.MEDIUM}
      spaceLeft="small"
    >
      {children}
    </AHText>
  );
};

export const ResultBlock: React.FC<
  React.PropsWithChildren<{ stale?: boolean }>
> = ({ children, stale }) => {
  const width = useSpaceSize("xxlarge");
  return (
    <View
      style={{
        width,
        alignItems: "center",
        flexDirection: "column",
        opacity: stale ? 0.7 : 1,
      }}
    >
      {children}
    </View>
  );
};
